import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { SidebarService } from "app/sidebar/sidebar.service";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { Globals } from 'app/services/globals';
import { utils } from 'protractor';
import { UtilsService } from 'app/services/utils.service';
import { ActiveModulesResource } from 'app/models/ActiveModulesResource';
import { UserResource } from 'app/models/UserResource';

@Component({
	selector: 'vbn-sidebar',
	providers: [SidebarService],
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

	currentSubmenu: number;
	errorMessage: string;
	adminProfileResource: AdminProfileResource;
	roleId: number;
	openMobileMenu: boolean = false;
	clientAccess = (localStorage.getItem("_roleId") === '2');
	adminAccess = (['1', '3', '4'].indexOf(localStorage.getItem("_roleId"))) > -1;

	isAppointmentModuleEnable: boolean = false;

	constructor(private _router: Router, private sidebarService: SidebarService,
		private globals: Globals,
		private service: UtilsService) {
		this.adminProfileResource = new AdminProfileResource();
		this.service.enableAppModule$.subscribe(
			resp => {
				this.isAppointmentModuleEnable = resp;
				if (this.globals.userProfile) {
					this.globals.userProfile.canUseAppointments = resp;
				}
				else {
					this.globals.userProfile = new UserResource();
					this.globals.userProfile.canUseAppointments = resp;

				}
			}
		)
	}

	ngOnInit() {
		//this.getAdminProfile();
		this.getUserProfile();
		//this.isModuleEnabled();

	}

	// isModuleEnabled(){
	// 	this.service.get("/admin/modules/getActiveModules")
	// 	.subscribe((resp: ActiveModulesResource) => {
	// 	  console.log("response = ", resp)
	// 	  this.isAppointmentModuleEnable = resp.appointment
	// 	})
	// }

	hasRights4Page(pageUrl) {
		let rightsObj = this.service.pageAccessRight(pageUrl);
		//console.log(" ====>>> For The page ",pageUrl, " the user ", rightsObj.client, "  has rights: ", rightsObj.right);
		return rightsObj.right;
	}
	/* 	getAdminProfile() {
			this.sidebarService.getAdminProfile()
				.subscribe(
					response => {
						this.adminProfileResource = response;
					},
					error => this.errorMessage = <any>error);
		} */

	lastTab: number;
	currentTab: number;
	showTab: boolean = false;

	selectSubmenu(id) {
		this.currentSubmenu = id;
	}

	show(id) {
		this.currentTab = id;
		if (this.showTab && this.lastTab != undefined && this.currentTab == this.lastTab) {
			this.showTab = false;
		} else {
			this.showTab = true;
		}
		this.lastTab = id;
		this.currentSubmenu = 0;
	}


	getUserProfile() {
		this.sidebarService.getUserProfile(`/admin/user/getProfile?userName=${atob(localStorage.getItem("_user"))}`).subscribe(
			body => {
				this.globals.userProfile = body
				this.roleId = this.globals.userProfile.role.rid
				if (body.role.rid != 1) {
					this.isAppointmentModuleEnable = body.canUseAppointments;
				}
			},
			error => console.error(error))
	}

	displayMobileMenu() {
		this.openMobileMenu = !this.openMobileMenu;
	}
	openHelp() {
		let link = "https://www.google.ro";
		window.open(link);
	}
}
